import ListColumnModel from '@/modules/base/model/list-column-model'

export default class UserListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)

    this.displayed = data.displayed
    this.setColumnSpecificProperties()
  }
  setColumnSpecificProperties() {
    switch (this.name) {

      case 'invitationDate':
      case 'lastLogin': {
        this.setDateType()
        break
      }
      default: { return }
    }
  }
}
